module.exports = __webpack_public_path__ + "static/grafika9@2x-153d12fe2dd47b6990b92e8da5bfa0dc.png";